import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlan } from '../../contexts/PlanContext';

/**
 * Single point of truth for every `openUpgrade(feature)` call in the app
 * (LockedFeature, Sidebar, LeadsPanel, IntegrationsPanel, DeveloperPanel,
 * AppearanceEditor, SettingsPanel, the 402 plan_upgrade_required handler
 * in App.js, ProfilesManager's profile-limit button). Used to show a
 * "contáctanos por WhatsApp" dead end instead of the real subscription
 * checkout — now it just forwards to /planes (PlansPage.js), which has
 * the actual checkout flow for Pro and books a meeting for Enterprise.
 * Renders nothing; the redirect happens as soon as openUpgrade() fires.
 */
const UpgradeModal = () => {
  const { upgradeModal, closeUpgrade } = usePlan();
  const navigate = useNavigate();

  useEffect(() => {
    if (!upgradeModal.open) return;
    const query = upgradeModal.feature ? `?feature=${encodeURIComponent(upgradeModal.feature)}` : '';
    closeUpgrade();
    navigate(`/planes${query}`);
  }, [upgradeModal.open, upgradeModal.feature, navigate, closeUpgrade]);

  return null;
};

export default UpgradeModal;
